<template>
  <div
    v-if="isItems"
    :id="id"
    :class="isPromoFix ? 'sub-block-margin promo-fix' : 'offers'"
  >
    <div class="main-container">
      <Custom
        :data="data"
        @openModal="openModal"
        @promo-banner-click="$emit('promo-banner-click')"
        @sendAnalytics="(value) => $emit('sendAnalytics', value)"
      />
    </div>
    <QuickViewOffer
      v-if="showQuickViewOffer"
      :model="data"
      @close="showQuickViewOffer = false"
    />
  </div>
</template>

<script lang="ts" src="./promo-offer-listTs.ts" />
<style lang="scss" src="./promo-offer-list.scss" scoped />
